
import { Action } from 'redux';

export const TTS_PLAY = 'TTS_PLAY';
export const TTS_PAUSE = 'TTS_PAUSE';
export const TTS_RESUME = 'TTS_RESUME';
export const TTS_RESET = 'TTS_STOP';
export const TTS_RATE_CHANGE = 'TTS_RATE_CHANGE';

interface SimpleTTSAction extends Action {
  type: typeof TTS_PLAY | typeof TTS_PAUSE | typeof TTS_RESUME | typeof TTS_RESET;
}
interface RateChangeTTSAction extends Action {
  type: typeof TTS_RATE_CHANGE;
  rate: number;
}

export type TTSAction = SimpleTTSAction | RateChangeTTSAction;

export function play(): SimpleTTSAction {
  return { type: TTS_PLAY };
}

export function pause(): SimpleTTSAction {
  return { type: TTS_PAUSE };
}

export function resume(): SimpleTTSAction {
  return { type: TTS_RESUME };
}

export function reset(): SimpleTTSAction {
  return { type: TTS_RESET };
}

export function rateChange(rate: number): RateChangeTTSAction {
  return { rate, type: TTS_RATE_CHANGE };
}

export const isTTSAction = (action: Action): action is TTSAction => {
  switch (action.type) {
    case TTS_PLAY:
    case TTS_PAUSE:
    case TTS_RESUME:
    case TTS_RESET:
    case TTS_RATE_CHANGE:
      return true;
    default:
      return false;
  }
};
